import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageRowProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    MessagePartContentProps
} from "../../type";
import {
    withMessageContext
} from "../../context";

const MessageRowContent: FC<MessagePartContentProps<IMessageRowProps>> = ({
    isShowActions = true,
    customTheme,
    children,
    context,
    style,
    ...props
}) => {
    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme ?? context.customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isSystem: context.isSystem,
        isPlain: context.isPlain,
        align: context.align,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
        {isShowActions && !context.isPlain ? context.actions : null}
    </View>;
};

const MessageRow = withMessageContext<IMessageRowProps>("Row", MessageRowContent);
export default MessageRow;
